"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _queryStringParser = _interopRequireDefault(require("../query-string-parser/query-string-parser"));

var _urls = _interopRequireDefault(require("./urls"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const VIDEO_INITIAL_LOAD_LIMIT = 20;
const VIDEO_LIMIT = 10;

class DashboardService {
  constructor(baseUrl, httpClient) {
    this.httpClient = httpClient;
    this.urls = (0, _urls.default)(baseUrl);
  }
  /**
   * Returns the user drafts and published videos
   * @param {Object} ctx - context object
   * @param {Object} config - Config object that contains the limit and page number
   */


  async getUserVideos(ctx, config = {}) {
    const firstPageConfig = _objectSpread({}, config);

    firstPageConfig.limit = VIDEO_INITIAL_LOAD_LIMIT; // fetch the drafts and published videos from the server

    const drafts = await this.fetchDraftVideos(ctx, firstPageConfig);
    const published = await this.fetchPublishVideos(ctx, firstPageConfig);
    return {
      drafts,
      published
    };
  }
  /**
   * Returns true if the user has at least one draft or published video
   * @param {draftVideos} draftVideos - list of drafts videos
   * @param {publishedVideos} publishedVideos - list of published videos
   */


  hasVideos(draftVideos, publishedVideos) {
    return draftVideos.length > 0 || publishedVideos.length > 0;
  }
  /**
   * Parse the video server response
   */


  parseVideosResponse(response) {
    // eslint-disable-next-line camelcase
    const {
      videos,
      has_next_page,
      cursor
    } = response;

    if (!videos) {
      return {
        videos: []
      };
    }

    const videosList = videos.map(video => {
      const {
        // eslint-disable-next-line camelcase
        id,
        create_date,
        ratio,
        thumbnail_url,
        title,
        video_url
      } = video;
      return {
        id,
        thumbnailUrl: thumbnail_url,
        videoUrl: video_url,
        title,
        createdDate: create_date,
        ratio
      };
    });
    return {
      videos: videosList,
      cursor,
      hasNextPage: has_next_page
    };
  }

  getVideos(ctx, config = {}, endpointUrl) {
    const url = this.getVideosUrl(endpointUrl, config);
    return this.httpClient.get(url, ctx);
  }

  getVideosUrl(videosUrl, config) {
    const {
      page,
      limit = VIDEO_LIMIT
    } = config;
    const params = {
      limit,
      cursor: page
    };

    const url = _queryStringParser.default.parseUrl(videosUrl, params);

    return url;
  }
  /**
   * Fetch the user draft videos
   */


  async fetchDraftVideos(ctx, config = {}) {
    const videos = await this.getVideos(ctx, config, this.urls.GET_DRAFT_VIDEOS);
    return this.parseVideosResponse(videos.data);
  }
  /**
   * Fetch the user published videos
   */


  async fetchPublishVideos(ctx, config = {}) {
    const videos = await this.getVideos(ctx, config, this.urls.GET_PUBLISH_VIDEOS);
    return this.parseVideosResponse(videos.data);
  }
  /**
   * Deletes video by id
   * @param {string} id - video id
   * @returns {boolean} - Returns true if the deletion was successful
   */


  async deleteVideo(id) {
    const response = await this.httpClient.delete(this.urls.DELETE_VIDEO(id));

    if (!response) {
      return false;
    }

    return true;
  }
  /**
   * Duplicates a video by id
   * @param {string} id - video id
   * @returns {Object} - new duplicated video data
   */


  async duplicateVideo(videoId) {
    const response = await this.httpClient.post(this.urls.DUPLICATE_VIDEO(videoId));

    if (!response) {
      return false;
    }

    const {
      data
    } = response;
    return this.parseVideo(data);
  }
  /**
   * Parse server video object to video object
   */


  parseVideo(video) {
    const {
      // eslint-disable-next-line camelcase
      id,
      thumbnail,
      ratio,
      title,
      createDate
    } = video;
    return {
      id,
      thumbnailUrl: thumbnail,
      ratio,
      title,
      createdDate: createDate
    };
  }

}

var _default = DashboardService;
exports.default = _default;